import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Container from '@material-ui/core/Container';
import Fade from '@material-ui/core/Fade';
import Backdrop from '@material-ui/core/Backdrop';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { useIsXLarge } from '../../../../../shared/theme';
import useFundsStateStore from '../../../common/funds-state-hook';
import Filter from './filter';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: props => (props.isXLarge ? '0 5%' : '0 32px'),
  },
}));

const MainContainer = withStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    outline: 'none',
  },
}))(Container);

const CrossButton = withStyles(() => ({
  root: {
    marginLeft: 'auto',
    marginBottom: 16,
    color: 'white',
    padding: 0,
  },
}))(IconButton);

const CrossIcon = withStyles(() => ({
  root: {
    fontSize: 28,
  },
}))(CloseIcon);

export default function FundTypesModal() {
  const isXLarge = useIsXLarge();
  const set = useFundsStateStore(state => state.set);
  const open = useFundsStateStore(state => state.showFundTypesModal);
  const modalClasses = useStyles({ isXLarge });

  const handleClose = () => {
    set(state => {
      state.showFundTypesModal = false;
    });
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      className={modalClasses.root}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 200,
      }}
    >
      <Fade in={open}>
        <MainContainer>
          <CrossButton onClick={handleClose}>
            <CrossIcon />
          </CrossButton>
          <Filter />
        </MainContainer>
      </Fade>
    </Modal>
  );
}
